import React from 'react';
import ToolTip from '../../ToolTip/ToolTip';


let isDragging = false;
export const GetOnDropHandle = (props) => e => {
    if (props.onListChange && props.listName) {
        props.onListChange(props.listName, e);
    }
};
export function GetOnDragEndFunctionHandle(props, list) {
    return ({ isSource }) => {
        isDragging = false;
        props.handleDragChange(isDragging, list, isSource);
    };
}
export function GetOnDragStartHandle(props, list) {
    return ({ isSource }) => {
        isDragging = true;
        props.handleDragChange(isDragging, list, isSource);
    };
}
export const getOverlayForItem = (props, itemIndex, item) => (
    <div
        className={props.containerClass + "__overlay"}
        onMouseEnter={e => props.showOverlay(e, isDragging, props.containerClass)}
        onMouseLeave={e => props.hideOverlay(e, props.containerClass)}
        onMouseUp={e => props.showOverlay(e, false, props.containerClass)}
        onMouseMove={e => props.showOverlay(e, isDragging, props.containerClass)}
    
    >
        {props.overlayButtons(() => isDragging, itemIndex)}
		<ToolTip item={item} isMobileOn={props.isMobileOn}/>
    </div>
);
